import { useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function PrivacyPolicyPage() {
  const [searchParams] = useSearchParams();
  const venueSlug = searchParams.get('venue') || 'demo';

  return (
    <div className="min-h-screen bg-page p-4">
      <div className="mx-auto max-w-3xl">
        {/* Header */}
        <div className="mb-6 flex items-center gap-3">
          <button
            onClick={() => window.history.back()}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-card shadow-md transition-transform hover:scale-105"
          >
            <ArrowLeft size={20} />
          </button>
          <h1 className="text-2xl font-bold text-text-main">Политика конфиденциальности</h1>
        </div>

        {/* Content */}
        <div className="space-y-6 rounded-brand bg-card p-6 shadow-md">
          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">1. Общие положения</h2>
            <p className="mb-2 text-sm text-text-muted">
              Настоящая Политика конфиденциальности персональных данных (далее — Политика) действует
              в отношении всех информации, которую программа лояльности может получить о
              Пользователе во время использования Telegram Mini App.
            </p>
            <p className="text-sm text-text-muted">
              Использование сервиса означает безоговорочное согласие Пользователя с настоящей
              Политикой и указанными в ней условиями обработки его персональной информации.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              2. Персональные данные пользователей
            </h2>
            <p className="mb-2 text-sm text-text-muted">
              В рамках настоящей Политики под «персональными данными Пользователя» понимаются:
            </p>
            <ul className="ml-6 list-disc space-y-1 text-sm text-text-muted">
              <li>
                Персональная информация, предоставляемая Telegram: имя, фамилия, username, Telegram
                ID
              </li>
              <li>Номер телефона (при добровольном предоставлении)</li>
              <li>История транзакций и начислений баллов</li>
              <li>История заказов и покупок</li>
              <li>Предпочтения и поведение в рамках программы лояльности</li>
              <li>IP-адрес и технические данные о взаимодействии с сервисом</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              3. Цели обработки персональных данных
            </h2>
            <p className="mb-2 text-sm text-text-muted">
              Персональные данные Пользователя обрабатываются в следующих целях:
            </p>
            <ul className="ml-6 list-disc space-y-1 text-sm text-text-muted">
              <li>Предоставление доступа к программе лояльности</li>
              <li>Начисление и списание бонусных баллов</li>
              <li>Обмен бонусов на награды</li>
              <li>Идентификация пользователя в системе</li>
              <li>Персонализация предложений и рекомендаций</li>
              <li>Отправка уведомлений о транзакциях и бонусах</li>
              <li>
                Отправка маркетинговых рассылок (только при отдельном согласии в соответствии с
                38-ФЗ)
              </li>
              <li>Улучшение качества сервиса и аналитика</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              4. Правовые основания обработки (152-ФЗ)
            </h2>
            <p className="mb-2 text-sm text-text-muted">
              Обработка персональных данных осуществляется на основании:
            </p>
            <ul className="ml-6 list-disc space-y-1 text-sm text-text-muted">
              <li>
                Федерального закона №152-ФЗ «О персональных данных» от 27.07.2006 (с изменениями)
              </li>
              <li>Явного согласия Пользователя на обработку его персональных данных</li>
              <li>Необходимости исполнения договора на предоставление услуг программы лояльности</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              5. Хранение и защита персональных данных
            </h2>
            <p className="mb-2 text-sm text-text-muted">
              Оператор принимает необходимые и достаточные организационные и технические меры для
              защиты персональной информации Пользователя:
            </p>
            <ul className="ml-6 list-disc space-y-1 text-sm text-text-muted">
              <li>Шифрование данных при передаче (HTTPS/TLS)</li>
              <li>Безопасное хранение данных в защищённых дата-центрах</li>
              <li>Ограничение доступа к персональным данным</li>
              <li>Регулярное резервное копирование</li>
              <li>Мониторинг несанкционированного доступа</li>
            </ul>
            <p className="mt-2 text-sm text-text-muted">
              Персональные данные хранятся в течение срока действия программы лояльности или до
              отзыва согласия Пользователем.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              6. Права субъекта персональных данных
            </h2>
            <p className="mb-2 text-sm text-text-muted">
              В соответствии с 152-ФЗ, Пользователь имеет право:
            </p>
            <ul className="ml-6 list-disc space-y-1 text-sm text-text-muted">
              <li>Получать информацию о обработке своих персональных данных</li>
              <li>Требовать уточнения, блокирования или уничтожения своих данных</li>
              <li>Отозвать согласие на обработку персональных данных</li>
              <li>Обжаловать действия Оператора в Роскомнадзор или суд</li>
            </ul>
            <p className="mt-2 text-sm text-text-muted">
              Удалить свои данные и отозвать согласия можно в разделе «Мои данные» приложения (ссылка
              внизу экрана) или обратившись в заведение. При удалении имя, телефон, Telegram ID и
              история уведомлений уничтожаются, баллы аннулируются; обезличенные записи об операциях
              с баллами и о согласиях хранятся для учёта и подтверждения согласия. Если баллы
              использовались, на срок до 3 лет сохраняется необратимая отметка (без номера и Telegram
              ID), чтобы приветственный бонус не начислялся повторно.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              7. Передача данных третьим лицам
            </h2>
            <p className="text-sm text-text-muted">
              Персональные данные Пользователя могут быть переданы третьим лицам только:
            </p>
            <ul className="ml-6 list-disc space-y-1 text-sm text-text-muted">
              <li>С явного согласия Пользователя</li>
              <li>В случаях, предусмотренных законодательством РФ</li>
              <li>
                Партнёрам для исполнения договора (платёжные системы, курьерские службы) при
                условии обеспечения конфиденциальности
              </li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              8. Использование cookies и аналитики
            </h2>
            <p className="text-sm text-text-muted">
              Сервис использует технологии cookies для улучшения работы приложения, аналитики и
              персонализации. Пользователь может управлять cookies через настройки браузера.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">
              9. Изменение Политики конфиденциальности
            </h2>
            <p className="text-sm text-text-muted">
              Оператор вправе вносить изменения в настоящую Политику. При внесении изменений
              Пользователь будет уведомлён через приложение. Новая версия Политики вступает в силу
              с момента её размещения, если иное не предусмотрено новой редакцией.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-semibold text-text-main">10. Контактная информация</h2>
            <p className="text-sm text-text-muted">
              По вопросам, связанным с обработкой персональных данных, обращайтесь к Оператору
              программы лояльности venue <strong>{venueSlug}</strong>.
            </p>
          </section>

          <div className="mt-6 rounded-lg bg-slate-50 p-4 text-xs text-slate-500">
            <p className="font-semibold">Дата вступления в силу: 26 января 2026</p>
            <p className="mt-1">Версия документа: 1.0</p>
          </div>
        </div>
      </div>
    </div>
  );
}
